// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csi-middleware-customView-CustomViewDialog-module-preview .propertyView .csi-view-scroll {
		background-color: var(--White50);
		padding: 12px;
	}

.csi-middleware-customView-CustomViewDialog-module-favoriteButton {
	margin-left: 4px;
	margin-right: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/csi/middleware/customView/CustomViewDialog.module.css"],"names":[],"mappings":"AACC;EACC,gCAAgC;EAChC,aAAa;CACd;;AAGD;CACC,gBAAgB;CAChB,iBAAiB;AAClB","sourcesContent":[".preview {\n\t:global .propertyView .csi-view-scroll {\n\t\tbackground-color: var(--White50);\n\t\tpadding: 12px;\n\t}\n}\n\n.favoriteButton {\n\tmargin-left: 4px;\n\tmargin-right: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"preview": `csi-middleware-customView-CustomViewDialog-module-preview`,
	"favoriteButton": `csi-middleware-customView-CustomViewDialog-module-favoriteButton`
};
module.exports = ___CSS_LOADER_EXPORT___;
